import React from 'react';

export default function Logout() {
  React.useEffect(() => {
    let token = '';
    fetch('/api/csrf', { credentials: 'include' })
      .then((res) => res.json())
      .then((data) => {
        token = data.token || '';
        return fetch('/api/auth/logout', {
          method: 'POST',
          credentials: 'include',
          headers: { 'X-CSRF-Token': token }
        });
      })
      .finally(() => {
        window.location.href = '/';
      });
  }, []);

  return (
    <div className="auth">
      <div className="auth-card">
        <h1>Signing out</h1>
        <p className="subtle">Please wait…</p>
      </div>
    </div>
  );
}
